import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { SectionEditPage, sectionQueryOptions } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/sections/$sectionId')({
  staticData: { tours: ['content.section-editor'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  loader: async ({ context, params }) => {
    const row = await context.queryClient.query({
      ...sectionQueryOptions(params.storeId, params.sectionId),
      staleTime: 'static',
    });
    return { crumb: row.name };
  },
  component: SectionEditPage,
});
